import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import DynamicImage from 'components/DynamicImage'
import { Text } from 'styles/components/typography'

import { ImageWrapper, SectionWrapperStyled, Col } from './styles'

/**
 * DHowAnalyse
 *
 * @param {object} props - properties of component
 * @returns {node} DHowAnalyse
 */
const WHowAnalyse = ({ data, index, isSquareHidden, pathCdn }) => {
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapperStyled isOverflowHidden={true}>
      <HowToBlock
        isSquareHidden={isSquareHidden}
        title={data.title}
        index={index}
        squareColor={colors.lilac}
        lineColor="light"
        textColor="light"
      >
        <div className="row">
          <Col className="col-12 col-md-5 col-lg-5 offset-md-1 pb-2 pb-md-4 pb-lg-0">
            <Text
              className="text--white with-inverted-links"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </Col>
          <ImageWrapper>
            <DynamicImage
              imageSizes={{ xs: 358, md: 772 }}
              image={`${pathCdn}/analyze/sequencer_v1`}
              imageType="png"
              alt="wgs sequencer"
              namesByBreakpoints
            />
          </ImageWrapper>
        </div>
      </HowToBlock>
    </SectionWrapperStyled>
  )
}

WHowAnalyse.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  pathCdn: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

WHowAnalyse.defaultProps = {
  isSquareHidden: false,
}

export default WHowAnalyse
